import { useEffect, useReducer, useState } from "react";
import { Modal } from "../../components/modal/Modal"
import { ContenedorParametros } from "../../components/utils/ContenedorParametros"
import { ContenedorTabla } from "../../components/utils/ContenedorTabla"
import { formatDate, notify, pintarFila, transformarArchivoUrl } from "../../../utils/utils";
import { MultiSelectorFecha } from "../../components/pickers/MultiSelectorFecha";
import { BotonNuevo } from "../../components/buttons/BotonNuevo";
import { BotonProcesar } from "../../components/buttons/BotonProcesar";
import { useModal } from "../../../hooks/useModal";
import { useGestionConocimientos } from "../../../hooks/gestionConocimientos/useGestionConocimientos";
import { EditorTexto } from "../../components/utils/EditorTexto";
import { ContenedorImagen } from "../../components/ContenedorImagen";
import { ModalProyecto } from "../../components/modal/ModalProyecto";

const imagenReducer = (estado, accion) => {
    switch(accion.tipo){
        case 'Agregar':
            return [...estado, ...accion.carga];
        case 'Remover':
            return estado.filter(file => file?.codigo ? 
                (file.codigo !== accion.carga.codigo) : (file.identificador !== accion.carga.identificador)
            );
        case 'Reiniciar':
            return []
        case 'Cargar':
            return accion.carga
        default:
            return estado;
    }
}

export const LeccionesAprendizaje = ()  => {
    const [ startDate, setStartDate ] = useState(() => {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() - 7);
        return formatDate(currentDate);
    });
    const [ endDate, setEndDate ] = useState(formatDate(new Date()));
    const [ isOpenModalLeccion, openModalLeccion, closeModalLeccion ] = useModal(null);
    const [ isOpenModalELiminarLeccion, openModalEliminarLeccion, closeModalELiminarLeccion ] = useModal(null);
    const [ imagenes, envioImagen ] = useReducer(imagenReducer, []);
    const datosEliminarDefault = {
        codGestionConocimiento: 0,
        motivoEliminacion: ""
    }
    const [ datosEliminar, setDatosEliminar ] = useState(datosEliminarDefault)
    const editarValorEliminacion = (key,value) =>{
        setDatosEliminar(leccion => {
            return {
                ...leccion,
                [key]: value
            }
        })
    }

    const idTabla = 'TablaLecciones';
    const classNameInput = "py-1 px-2 caret-white containerScroll text-white  rounded  bg-zinc-900 text-l focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:opacity-70 disabled:cursor-not-allowed";
    const classNameSelect = "py-1 px-2 containerScroll text-white  rounded  bg-zinc-900 text-l focus:outline-none focus:ring-1 focus:ring-blue-500";

    {/* LOGICA PARA EL GUARDADO DE ARCHIVOS */}
    const parseURLArchivo = async (archivos) => {
        return archivos.map(option => {
            const nuevoObjeto = {};
            Object.keys(option).forEach(key => {
                if(key === 'codArchivo'){
                    nuevoObjeto.codigo = option[key];
                }
                else
                    if(key.startsWith('nom')){
                        nuevoObjeto.nom = option[key];
                    }
                    else
                        if(key.startsWith('url')){
                            nuevoObjeto.url = option[key];
                        }
            });
            return nuevoObjeto;
        })
    }
    
    const {
        listarNivelImpacto,
        listaNivelesImpacto,
        listarLeccionesAprendizaje,
        lecciones,
        listarDetalleLeccion,
        detalleLeccion,
        editarValorLeccion,
        listarCategoriaConocimiento,
        listaCategoriaConocimiento,
        listarServicios,
        listaServicio,
        guardarEditarLeccionesAprendizaje,
        eliminarLeccionAprendizaje

    } = useGestionConocimientos()

    useEffect(() => {
        listarServicios();
        listarCategoriaConocimiento();
        listarNivelImpacto();
        listarLeccionesAprendizaje();
    },[])

    useEffect(() => {
        const asincronaImg = async () => {
            const urlImagen = await parseURLArchivo(detalleLeccion.listaImagenesLesson);
            envioImagen({ tipo: 'Cargar', carga: urlImagen});
        }
        detalleLeccion.listaImagenesLesson.length > 0 ? asincronaImg() : envioImagen({tipo: 'Reiniciar'});
    },[detalleLeccion.listaImagenesLesson])

    const esNuevoArchivo = (item) => item instanceof File || (item.constructor && item.constructor.name === 'File') 

    const registrarLeccionAprendizaje = async () => {
        let urlImagen = [];
        const camposAValidar = [ "titulo", "descripcionSituacion", "descripcionSolucion", "codCategoriaConocimiento","codImpacto" ]
        const validarLeccion = camposAValidar.some(campo => detalleLeccion[campo] === "" || detalleLeccion[campo] === null || detalleLeccion[campo] === 0 || detalleLeccion[campo] === undefined);
        if(validarLeccion){
            notify("Falta completar datos del formulario", "warning");
            return
        }

        {/*Aca debe ir la correccion de la imagenes edicion */}
        if(imagenes.length > 0){
            if(detalleLeccion.listaImagenesLesson.length === 0){
                urlImagen = await transformarArchivoUrl(imagenes) ;
            }
            else{
                const nuevasImagenes = imagenes.filter(img => esNuevoArchivo(img));
                const imagenesBD = detalleLeccion.listaImagenesLesson.filter(img =>  imagenes.some(imagen => imagen.codigo === img.codAux));
                const imagenesNuevas = await transformarArchivoUrl(nuevasImagenes);
                urlImagen = [ ...imagenesBD, ...imagenesNuevas ];
            }
        }
        const isValid = await guardarEditarLeccionesAprendizaje(urlImagen);
        if(isValid)
        {
            await listarLeccionesAprendizaje()
            closeModalLeccion();
        }
    }

    const EliminarLeccion = async () => {
        const camposAValidar = ["motivoEliminacion"];
        const validarEliminacion = camposAValidar.some(campo => datosEliminar[campo] === "" || datosEliminar[campo] === null || datosEliminar[campo] === 0 || datosEliminar[campo] === undefined);
        if(validarEliminacion){
            notify("Falta completar datos del formulario", "warning");
            return
        }
        const isValid = await eliminarLeccionAprendizaje(datosEliminar.codGestionConocimiento, datosEliminar.motivoEliminacion)
        if(isValid){
            await listarLeccionesAprendizaje();
        }
    }

    const labelEstado = (codEstado, nomEstado) => {
        let color = ' bg-gray-600 ';
        switch(codEstado){
            case 1: color = ' bg-green-600 ';
            break;
            case 10: color = ' bg-red-600 ';
            break;
            default: color = ' bg-yellow-600 '
        }
        return <span className={`inline-block w-[60px] px-2 text-center ${color}  rounded `}>{nomEstado}</span>
    }

    return(
        <>
            <ContenedorParametros
                titulo="Lecciones y aprendizaje"
                tablaId={idTabla}
            >
                <BotonNuevo onClick={() => {
                        listarDetalleLeccion();
                        openModalLeccion();
                    }}
                />
                <BotonProcesar onClick={() => listarLeccionesAprendizaje()}/>
            </ContenedorParametros>
            
            <ContenedorTabla>
                <table className="tableResponsive" id={idTabla}>
                    <thead>
                        <tr key={'thead_lecciones'}>
                            <th className="w-[50px] max-w-[50px] min-w-[50px]">N</th>
                            <th>COD</th>
                            <th>TITULO</th>
                            <th>CATEGORÍA</th>
                            <th>PROYECTO RELAC.</th>
                            <th>DESCRIPCIÓN SITUACIÓN</th>
                            <th>DESCRIPCIÓN SOLUCIÓN</th>
                            <th>FECHA REGISTRO</th>
                            <th>AUTOR</th>
                            <th>IMPACTO</th>
                            <th>ESTADO</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            lecciones.length > 0 ? 
                                lecciones.map((lec, i) => (
                                    <tr key={`fila_${i}`} onClick={(e) => pintarFila(e.target)}>
                                        <td className="text-center">{i + 1}</td>
                                        <td className="w-[60px] text-center min-w-[60px] max-w-[70px]">
                                            <span className="w-[55px] px-2 rounded inline-block text-center bg-blue-600">{lec.codigoConocimiento}</span>
                                        </td>
                                        <td className="w-[300px] min-w-[280px] max-w-[300px]">
                                            <div className="w-[95%] whitespace-nowrap text-ellipsis overflow-hidden">{lec.titulo}</div>
                                        </td>
                                        <td className="text-center w-[200px] min-w-[200px]">{lec.nomCategoriaConocimiento}</td>
                                        <td className="text-center w-[200px] min-w-[200px]">{lec.nomProyecto}</td>
                                        <td className="w-[250px] min-w-[250px] max-w-[260px]">
                                            <div className="w-[95%] whitespace-nowrap text-ellipsis overflow-hidden">{lec.descripcionSituacion.replace(/<[^>]*>/g, '')}</div>
                                        </td>
                                        <td className="w-[250px] min-w-[250px] max-w-[260px]">
                                            <div className="w-[95%] whitespace-nowrap text-ellipsis overflow-hidden">{lec.descripcionSolucion.replace(/<[^>]*>/g, '')}</div>
                                        </td>
                                        <td className="w-[140px] min-w-[140px] text-center">{lec.fechaCreacion}</td>
                                        <td className="w-[150px] text-center">{lec.autor}</td>
                                        <td className="w-[150px] text-left whitespace-nowrap">
                                            {lec.nomImpacto + ' '} 
                                            <i
                                                className={`fa fa-circle text-[10px] ${lec.codImpacto === 1 ? 'text-yellow-500' : 
                                                    (lec.codImpacto === 2 ? 'text-orange-500' : 
                                                        (lec.codImpacto === 3 ? 'text-red-500' : 'text-black')
                                                    )}
                                                `}
                                            ></i>
                                        </td>
                                        <td>{labelEstado(lec.codEstado,lec.nomEstado)}</td>
                                        <td>
                                            <i
                                                className="fa fa-edit text-blue-600"
                                                title="Editar lección y aprendizaje"
                                                onClick={async () => {
                                                    await listarDetalleLeccion(lec)
                                                    openModalLeccion()
                                                }}
                                            ></i>
                                        </td>
                                        <td>
                                            <i 
                                                className="fa fa-trash text-red-600"
                                                title="Eliminar lección y aprendizaje"
                                                onClick={() => {
                                                    editarValorEliminacion("codGestionConocimiento", lec.codGestionConocimiento)
                                                    editarValorEliminacion("motivoEliminacion", "")
                                                    openModalEliminarLeccion()
                                                }}
                                            ></i>
                                        </td>
                                    </tr>
                                ))
                            :
                                <tr>
                                    <td colSpan={13} className="text-center">No hay información para mostrar...</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </ContenedorTabla>
            
            {/* MODAL PARA REGISTRAR Y EDITAR LECCIÓN Y APRENDIZAJE */}
            <ModalProyecto
                isOpen={isOpenModalLeccion}
                closeModal={closeModalLeccion}
                title={detalleLeccion.codGestionConocimiento === 0 ? 'Crear lección y aprendizaje' : `Editar lección [ ${detalleLeccion.codGestionConocimiento} ]`}
                action={() => registrarLeccionAprendizaje()}
                clasesModal="h-[700px] lg:h-full w-[70%]"
            >
                <div
                    key="contentLeccion"
                    className="p-5 w-full grid grid-cols-[minmax(0,10fr)_minmax(0,40fr)_minmax(0,10fr)_minmax(0,40fr)] 
                        lg:grid-cols-[minmax(0,20fr)_minmax(0,30fr)_minmax(0,20fr)_minmax(0,30fr)]
                        lg:gap-x-2 lg:text-xs gap-x-10 gap-y-2 items-center lg:break-words"
                >
                    <label htmlFor="tituloLeccion">Título</label>
                    <input
                        id="tituloLeccion"
                        className={classNameInput}
                        value={detalleLeccion.titulo}
                        onChange={(e) => editarValorLeccion("titulo", e.target.value)}
                    />
                    <label htmlFor="nomProyecto">Proyecto</label>
                    <select
                        id="nomProyecto"
                        className={classNameInput}
                        value={detalleLeccion.codGestionInfraestructuraAplicacion}
                        onChange={(e) => editarValorLeccion("codGestionInfraestructuraAplicacion", Number(e.target.value))}
                    >
                        <option key={'opcionSeleccioneProyecto'} value={0}>--Seleccione--</option>
                        {
                            listaServicio.length > 0 ?
                                listaServicio.map(ser => (
                                    <option key={ser.codGestionInfraestructuraAplicacion} value={ser.codGestionInfraestructuraAplicacion}>{ser.nomProyecto}</option>
                                ))
                            :
                                <></>
                        }
                    </select>
                    <label htmlFor="selectCategoria">Categoría</label>
                    <select
                        id="selectCategoria"
                        className={classNameSelect}
                        value={detalleLeccion.codCategoriaConocimiento}
                        onChange={(e) => editarValorLeccion("codCategoriaConocimiento", Number(e.target.value))}
                    >
                        <option key={'opcionSeleccioneCategoria'} value={0}>-- Seleccione --</option>
                        {
                            listaCategoriaConocimiento.length > 0 ?
                                listaCategoriaConocimiento.map(cat => (
                                    <option key={cat.codCategoriaConocimiento} value={cat.codCategoriaConocimiento}>{cat.nomCategoriaConocimiento}</option>
                                ))
                            :
                                <></>
                        }
                    </select>
                    <label htmlFor="selectImpacto">Impacto</label>
                    <select
                        id="selectImpacto"
                        className={classNameSelect}
                        value={detalleLeccion.codImpacto}
                        onChange={(e) => editarValorLeccion("codImpacto", Number(e.target.value))}
                    >
                        <option key={'opcionSeleccioneImpacto'} value={0}>--Seleccione--</option>
                        {
                            listaNivelesImpacto.length > 0 ? 
                                listaNivelesImpacto.map(niv => (
                                    <option key={'nivelImpacto_' + niv.codImpacto} value={niv.codImpacto}>{niv.nomImpacto}</option>
                                ))
                            :
                                <></>
                        }
                    </select>
                    <label htmlFor="documentacion">Documentación</label>
                    <input
                        id="documentacion"
                        className={classNameInput}
                        value={detalleLeccion.documentacion}
                        onChange={(e) => editarValorLeccion("documentacion", e.target.value)}
                    />
                    <label htmlFor="etiqueta">Etiqueta</label>
                    <input
                        id="etiqueta"
                        className={classNameInput}
                        value={detalleLeccion.etiqueta}
                        onChange={(e) => editarValorLeccion("etiqueta", e.target.value)}
                    />
                    
                    <label htmlFor="descSituacion">Descripción situación</label>
                    <div className="col-span-3 relative w-full lg:h-[176px] editor-quill-container " key={'contentSituacion'}>
                        <EditorTexto
                            keyEditor={'descripcionSituacion'}
                            setValueEdit={editarValorLeccion}
                            valueEdit={detalleLeccion.descripcionSituacion}
                        />
                    </div>
                    <label htmlFor="descSolucion">Descripción solución</label>
                    <div className="col-span-3 w-full lg:h-[176px] editor-quill-container " key={'contentSolucion'}>
                        <EditorTexto
                            keyEditor={'descripcionSolucion'}
                            setValueEdit={editarValorLeccion}
                            valueEdit={detalleLeccion.descripcionSolucion}
                        />
                    </div>
                    <label>Imagenes</label>
                    <div key={'content_img'} className=" h-[120px] lg:h-[100px] lg:col-span-3">
                        <ContenedorImagen
                            envioImagen={envioImagen}
                            archivo={imagenes}
                            esBloqueo={false}
                            showThumbs={false}
                        />
                    </div>
                    <label htmlFor="recomendaciones">Recomendaciones</label>
                    <textarea
                        id="recomendaciones"
                        className={classNameInput + ' h-[120px] resize-none lg:h-[100px] lg:col-span-3 border border-zinc-700'}
                        value={detalleLeccion.recomendacion}
                        onChange={(e) => editarValorLeccion("recomendacion", e.target.value)}
                    />
                </div>
            </ModalProyecto>

            {/* MODAL PARA ELIMINAR LECCIÓN Y APRENDIZAJE */}
            <Modal
                isOpen={isOpenModalELiminarLeccion}
                closeModal={closeModalELiminarLeccion}
                action={() => EliminarLeccion()}
                title={`Eliminar Lección y aprendizaje [${datosEliminar.codGestionConocimiento}]`}
                textButtons={{confirm: 'Guardar', denied: 'Cancelar'}}
            >
                <div className='grid gap-2 py-3 w-[350px]'>
                    <strong className="">Motivo:</strong>
                    <textarea className={`${classNameInput} h-[80px] resize-none`} placeholder="Escriba aquí el motivo de la eliminación de leccion y aprendizaje..."/>
                </div>
            </Modal>
        </>
    )
}